export default function CsharpGetStarted() {
  return (
    <h2>Csharp Get Started</h2>
  );
}
